"use client";
import { jsx as e, Fragment as C } from "react/jsx-runtime";
import { createSvgIcon as o } from "@mui/material/utils";
const l = o(
  /* @__PURE__ */ e(C, { children: /* @__PURE__ */ e(
    "path",
    {
      d: "M17.5 1.79004H6.50004C3.90004 1.79004 1.79004 3.90004 1.79004 6.50004V17.5C1.79004 20.1 3.90004 22.21 6.50004 22.21H17.5C20.1 22.21 22.21 20.1 22.21 17.5V6.50004C22.21 3.90004 20.1 1.79004 17.5 1.79004ZM16.1 9.38004L11.6 16.38C11.48 16.57 11.27 16.69 11.05 16.71C11.04 16.71 11.02 16.71 11.01 16.71C10.8 16.71 10.6 16.62 10.46 16.45L7.96004 13.45C7.71004 13.15 7.75004 12.7 8.05004 12.45C8.35004 12.2 8.80004 12.24 9.05004 12.54L10.93 14.8L14.91 8.61004C15.12 8.28004 15.56 8.19004 15.89 8.40004C16.22 8.61004 16.32 9.05004 16.1 9.38004Z",
      fill: "currentColor"
    }
  ) }),
  "KmxCheckboxCheckedFilled"
);
export {
  l as default
};
